import logo from '../../assets/icons/logo.svg';

function Desktop() {
  return ( 

    <div className='header'>
      <img className='header__logo' src={logo} alt="logo AquaTime" />
      <nav className='header__menu'>
        <a className='header__menu-link' href="#about">О нас</a>
        <a className='header__menu-link' href="#services">Услуги</a>
        <a className='header__menu-link' href="#changes">Наш подход</a>
        <a className='header__menu-link' href="#prices">Цены</a>
        <a className='header__menu-link' href="#faq">FAQ</a>
        <a className='header__menu-link' href="#reviews">Отзывы</a>
        <a className='header__menu-link' href="#location">Контакты</a>
      </nav>
      <a className='header__button' href="https://n1386588.yclients.com"><p>Записаться</p></a>
    </div>
   );
}

export default Desktop;